import "./TemplatesMenu.scss";

export default function TemplatesMenu() {
  return (
    <div className={"templates-menu"}>
      <ul>
        <li className="img">
          <a href={"/menu/browse.do"}>
            <img
              loading="lazy"
              src={"https://timber.mhmcdn.com/site/marketing/templatesdropdown/MenusThumb.webp"}
              alt={"menus"}
            />
            <h6>Menus</h6>
          </a>
        </li>
        <li>
          <div className="most-popular-tag">
            <a href="/menu/browse.do">Dine-In</a>
            {/* <span>Most Popular</span> */}
          </div>
        </li>
        <li>
          <a href="/category/table-tent.html">Table Tent</a>
        </li>
        <li>
          <a href="/category/takeout-menus.html">Takeout</a>
        </li>
        <li>
          <a href="/category/half-page-menus.html">Half Page</a>
        </li>
        <li>
          <a href="/category/kids%27-menus.html">Kids Menus</a>
        </li>
        <li>
          <a href="/category/cafe-menus.html">Cafe Menus</a>
        </li>
      </ul>

      <ul>
        <li className="img">
          <a href={"/category/marketing-templates.html"}>
            <img
              loading="lazy"
              src={"https://timber.mhmcdn.com/site/marketing/templatesdropdown/MarketingThumb.webp"}
              alt={"menus"}
            />
            <h6>Marketing</h6>
          </a>
        </li>

        <li>
          <a href="/category/restaurant-flyer.html">Flyers</a>
        </li>
        <li>
          <a href="/category/restaurant-posters.html">Posters</a>
        </li>
        <li>
          <a href="/category/table-tent.html">Table Tents</a>
        </li>
        <li>
          <a href="/category/gift-certificates.html">Gift Cards</a>
        </li>
        <li>
          <a href="/category/punch-cards.html">Punch Cards</a>
        </li>
        <li>
          <a href="/category/comment-cards.html">Comment Cards</a>
        </li>
        <li>
          <a href="/category/business-cards.html">Business Cards</a>
        </li>
        <li>
          <a href="/category/logos.html">Logos</a>
        </li>
        <li>
          <a href="/category/stickers.html">Stickers</a>
        </li>
        <li>
          <a href="/category/food-labels.html">Food Labels</a>
        </li>
      </ul>

      <ul>
        <li className="img">
          <a href={"/category/Digital-Menu-Boards.html"}>
            <img
              loading="lazy"
              src={"https://timber.mhmcdn.com/site/marketing/templatesdropdown/DigitalDisplayThumb.webp"}
              alt={"menus"}
            />
            <h6>Digital Menus</h6>
          </a>
        </li>
        <li>
          <a href="/category/Digital-Menu-Boards.html">Digital Menu Boards</a>
        </li>
        <li>
          <a href="/category/digital-signage.html">Digital Signage</a>
        </li>
        <li>
          <a href="/category/coffee-house-digital-menu-board.html">Coffee House Displays</a>
        </li>
        <li>
          <a href="/category/dispensary-digital-menu-board.html">Dispensary Displays</a>
        </li>
        <li>
          <a href="/category/pizza-digital-menu-board.html">Pizza Displays</a>
        </li>
        <li>
          <a href="/category/tall-digital-menu-boards.html">Tall Displays</a>
        </li>
      </ul>

      <ul>
        <li className="img">
          <a href={"/category/social-media-templates.html"}>
            <img
              loading="lazy"
              src={"https://timber.mhmcdn.com/site/marketing/templatesdropdown/SocialThumb.webp"}
              alt={"menus"}
            />
            <h6>Social</h6>
          </a>
        </li>
        <li>
          <a href="/category/instagram-posts.html">Instagram Posts</a>
        </li>
        <li>
          <a href="/category/instagram-stories.html">Instagram Stories</a>
        </li>
        <li>
          <a href="/category/facebook-posts.html">Facebook Posts</a>
        </li>
        <li>
          <a href="/category/facebook-stories.html">Facebook Stories</a>
        </li>
      </ul>

      <ul>
        <li className="img">
          <a href={"/category/seasonal-flyers.html"}>
            <img
              loading="lazy"
              src={"https://timber.mhmcdn.com/site/marketing/templatesdropdown/SeasonalThumb.webp"}
              alt={"menus"}
            />
            <h6>Seasonal</h6>
          </a>
        </li>
        <li>
          <a href="/category/summer-menus.html">Summer Menus</a>
        </li>
        <li>
          <a href="/category/summer-flyers.html">Summer Flyers</a>
        </li>
        <li>
          <a href="/template/bbq-flyers.html ">BBQ Flyers</a>
        </li>
        <li>
          <a href="/template/ice-cream-menus.html">Ice Cream Menus</a>
        </li>
      </ul>
    </div>
  );
}
